import { http } from './http'
import { auth } from './auth'
import { parseWithZod } from '../utils/parse-with-zod'
import z from 'zod'
import { CreateBlacklinePayload } from '../types'
import { BlacklineSchema } from '../schemas'

const BlacklineResponseSchema = z.object({
  blackline: BlacklineSchema,
})

export const blacklines = {
  create: async (payload: CreateBlacklinePayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/blacklines`, { blackline: payload }, dealId)
    return parseWithZod(BlacklineResponseSchema, result).blackline
  },
}
